module.exports = __webpack_public_path__ + "static/media/KNC-logo.3eeb6809.png";